import { type FC } from 'react';

interface pressreleaseProps {
  pressrelease: any;
}

const PressReleaseHome: FC<pressreleaseProps> = ({ pressrelease }) => {
  return (
    <div className="group grid content-between border-t border-border/35 pt-5 transition-colors hover:border-text/60">
      <div className="top">
        <div className="relative h-[250px] overflow-hidden rounded-sm md:h-[320px]">
          {pressrelease.base64 ? (
            <img
              src={`data:image/jpeg;base64,${pressrelease.base64}`}
              alt={pressrelease.name}
              className="absolute object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <img
              src={`/folder-placeholder.jpg`}
              alt={pressrelease.name}
              className="absolute object-cover w-full h-full transition-transform duration-500 group-hover:scale-105"
            />
          )}
        </div>
        <p className="my-4 text-xs font-semibold uppercase text-muted"> {pressrelease.date}</p>
        <h3 className="mb-3 text-2xl md:text-3xl">{pressrelease.title}</h3>
        <div
          dangerouslySetInnerHTML={{ __html: pressrelease.text }}
          className="default-html text-muted"
        />
      </div>
      <div className="bottom">
        <a
          download
          target="_blank"
          rel="noreferrer"
          href={
            process.env.REACT_APP_CUSTOMER_PUBLIC_FILES_URL +
            '/' +
            pressrelease.file
          }
          className="brand-link group/link mt-6"
        >
          <span>Download press release</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            className="brand-arrow inline-block h-6 w-6 cursor-pointer bg-opacity-50 p-[3px] transition-transform group-hover/link:translate-y-0.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  );
};
export default PressReleaseHome;
